<template>

  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 111.628 111.628">
    <path id="Good"
      d="M1370.887,0A55.814,55.814,0,1,0,1426.7,55.813,55.877,55.877,0,0,0,1370.887,0m18.921,34.294a6.627,6.627,0,1,1-6.627,6.627,6.627,6.627,0,0,1,6.627-6.627m-37.843,0a6.627,6.627,0,1,1-6.627,6.627,6.627,6.627,0,0,1,6.627-6.627m45.95,28.19a27.86,27.86,0,0,1-54.057,0,2.68,2.68,0,0,1,5.2-1.3,22.5,22.5,0,0,0,43.656,0,2.68,2.68,0,0,1,5.2,1.3"
      transform="translate(-1315.073 0.001)" :fill="themeColor" />
  </svg>


</template>

<script>
import { mapWritableState } from 'pinia';
import { useChatSettingsStore } from '../../../../store/ChatSettingsStore/ChatSettingsStore';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#B3B3B3',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '50px',
    },
    width: {
      type: String,
      required: false,
      default: '100px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
